export const SCRIPT_SRC =
  '//translate.google.com/translate_a/element.js?cb=initGoogleTranslate';
export const EL_SCRIPT_SRC =
  '//translate.google.com/translate_a/element.js?cb=initGoogleTranslateElementary';

export const SCRIPT_SELECTORS = [
  '#goog-gt-tt',
  '.goog-te-spinner-pos',
  'iframe.goog-te-menu-frame.skiptranslate',
  'div.skiptranslate',
];
